import { render, staticRenderFns } from "./models.vue?vue&type=template&id=1b6064bd&scoped=true"
import script from "./models.vue?vue&type=script&lang=js"
export * from "./models.vue?vue&type=script&lang=js"
import style0 from "./models.vue?vue&type=style&index=0&id=1b6064bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6064bd",
  null
  
)

export default component.exports